<h2 mat-dialog-title>{{ 'PORTAL.CONFIRM_WAITING_LIST_EXIT.TITLE' | translate }}</h2>
<mat-dialog-content>
  <p>{{ 'PORTAL.CONFIRM_WAITING_LIST_EXIT.MESSAGE' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" [mat-dialog-close]="false">
    {{ 'PORTAL.CONFIRM_WAITING_LIST_EXIT.CANCEL' | translate }}
  </button>
  <button mat-stroked-button [mat-dialog-close]="true">
    {{ 'PORTAL.CONFIRM_WAITING_LIST_EXIT.CONFIRM' | translate }}
  </button>
</mat-dialog-actions>
